<template>
  <div>
    <div class="flow-block">
      <h4 class="flow-title">Dashes disponíveis</h4>
      <p class="flow-subtitle">
        Marque todas as dashes que farão parte dessa importação. Você poderá escolher, em cada planilha, quais delas vão recebê-la.
      </p>
      <div class="step-status-item" :class="{ ok: selectedTenantsList.length > 0 }">
        Selecionadas: {{ selectedTenantsList.length }}
      </div>
      <div class="mt-2">
        <tenants-slim-list
          checkbox
          minimum
          searchable
          search-placeholder="Filtrar dash por nome"
          :only-actives="true"
          :selecteds="tenantIds"
          @selectedTenant="$emit('selected-tenants', $event)"
        />
      </div>
    </div>

    <div class="flow-block mt-4">
      <h4 class="flow-title">Suas planilhas</h4>
      <p class="flow-subtitle">
        Cada planilha vira uma categoria de contato nas dashes escolhidas. Você pode aplicar a mesma planilha em várias dashes ou subir planilhas diferentes para cada uma.
      </p>
      <p class="flow-subtitle warning-tip">
        <strong>Importante:</strong> a planilha precisa ter uma coluna com o nome do contato e outra com o telefone.
      </p>

      <div class="upload-cards">
        <mass-customer-category-upload-card
          v-for="(card, cardIndex) in uploads"
          :key="card.localId"
          :card="card"
          :position="cardIndex + 1"
          :available-tenants="selectedTenantsList"
          :disable-upload="selectedTenantsList.length === 0"
          @remove="$emit('remove-card', cardIndex)"
          @file-chosen="$emit('file-chosen', { cardIndex, file: $event })"
          @sheet-changed="$emit('sheet-changed', { cardIndex, sheetIndex: $event })"
          @update-field="$emit('update-field', { cardIndex, ...$event })"
          @set-all-tenants="$emit('set-all-tenants', { cardIndex, marked: $event })"
          @toggle-tenant="$emit('toggle-tenant', { cardIndex, tenantId: $event })"
        />
      </div>

      <div class="mt-4">
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          :disabled="selectedTenantsList.length === 0"
          @click="$emit('add-card')"
        >
          Adicionar outra planilha
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import TenantsSlimList from '@/views/Tenants/TenantsSlimList.vue';
import MassCustomerCategoryUploadCard from './MassCustomerCategoryUploadCard.vue';

export default {
  name: 'MassCustomerCategoriesStepUploads',
  components: {
    TenantsSlimList,
    MassCustomerCategoryUploadCard,
  },
  props: {
    tenantIds: {
      type: Array,
      required: true,
    },
    selectedTenantsList: {
      type: Array,
      required: true,
    },
    uploads: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
